import Vue from 'vue'
import store from '../store'
import axios from 'axios'
import localForage from 'localforage'

const mixins = Vue.mixin({
  methods: {
    validateModalEmail (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    NavigateArrow (key) {
      switch (key.keyCode) {
        case 38 : this.upArrow()
          break
        case 40 : this.downArrow()
          break
      }
    },
    upArrow () {
      console.log('up')
    },
    downArrow () {
      console.log('down')
    },
    addBodyClass () {
      let windowWidth = window.innerWidth
      let ordersSlideout = document.getElementById('orders-slideout')
      let productSlideout = document.getElementById('product-slideout')
      let offersSlideout = document.getElementById('offers-slideout')
      let bodyCheck = document.body
      let slideoutGroup = [ordersSlideout, productSlideout, offersSlideout]
      let slideOpen = false
      for (let i = 0; i < slideoutGroup.length; i++) {
        if (slideoutGroup[i] && slideoutGroup[i].classList.contains('slideout-open')) {
          slideOpen = true
          break
        }
      }
      if (slideOpen && windowWidth <= 768) {
        bodyCheck.classList.add('set-overflow')
      } else {
        bodyCheck.classList.remove('set-overflow')
      }
    },
    removeBodyClass () {
      let windowWidth = window.innerWidth
      let bodyCheck = document.body
      if (windowWidth <= 768) {
        bodyCheck.classList.remove('set-overflow')
      }
    },
    // slideoutCheck () {
    //   let ordersSlideout = document.getElementById('orders-slideout')
    //   let productSlideout = document.getElementById('product-slideout')
    //   let offersSlideout = document.getElementById('offers-slideout')
    //   let bodyCheck = document.body
    //   let slideoutGroup = [ordersSlideout, productSlideout, offersSlideout]
    //   let slideOpen = false
    //   for (let i = 0; i < slideoutGroup.length; i++) {
    //     console.log(1)
    //     if (slideoutGroup[i] && slideoutGroup[i].classList.contains('slideout-open')) {
    //       slideOpen = true
    //       return true
    //     }
    //   }
    //   if (slideOpen) {
    //     bodyCheck.classList.add('set-overflow')
    //   } else {
    //     bodyCheck.classList.remove('set-overflow')
    //   }
    // },
    scrollToLastProduct (data, selector) {
      let vm = this
      let parent = document.querySelector('.' + selector)
      if (parent.scrollHeight > parent.clientHeight) {
        setTimeout(function () {
          let targetJQ = window.$('[data-order-row-id="' + data.product.id + '"]')
          let productQty = null
          if (vm.offer_rows) {
            productQty = vm.offer_rows['products'].find(product => parseInt(product.id) === parseInt(data.product.id))
          }
          if (vm.order_rows) {
            productQty = vm.order_rows['products'].find(product => parseInt(product.id) === parseInt(data.product.id))
          }
          if (vm.invoice_rows) {
            productQty = vm.invoice_rows['products'].find(product => parseInt(product.id) === parseInt(data.product.id))
          }
          if (productQty.qty > 1) {

          } else {
            window.$('.' + selector).animate({
              scrollTop: window.$(targetJQ).offset().top
            })
          }
        }, 300)
      }
    },
    formatDatesForVueDatePicker (date) {
      if (date !== null) {
        let d = new Date(date)
        let month = '' + (d.getMonth() + 1)
        let day = '' + d.getDate()
        let year = d.getFullYear()
        if (String(month).length < 2) month = '0' + month
        if (String(day).length < 2) day = '0' + day
        return [day, month, year].join('-')
      }
      return false
    },
    formatDatesWithTime (date) {
      if (date !== null) {
        let d = new Date(date)
        let month = '' + (d.getMonth() + 1)
        let day = '' + d.getDate()
        let year = d.getFullYear()
        let hour = d.getHours()
        let minutes = d.getMinutes()

        if (String(month).length < 2) month = '0' + month
        if (String(day).length < 2) day = '0' + day
        if (String(hour).length < 2) hour = '0' + hour
        if (String(minutes).length < 2) minutes = '0' + minutes
        return [day, month, year].join('-') + ' ' + [hour, minutes].join(':')
      }
      return false
    },
    clientName (user) {
      if (user) {
        if (user.mentor_name && user.mentor_name !== '') {
          let marca = user.marca ? ' (' + user.marca + ')' : ''
          return user.mentor_name + marca
        }
        if (parseInt(user.type) === 2 && user.company_name) {
          return `${user.company_name}`
        } else {
          if (user.first_name && user.last_name) {
            return `${user.first_name} ${user.last_name}`
          } else if (user.first_name) {
            return `${user.first_name}`
          } else if (user.last_name) {
            return `${user.last_name}`
          }
        }
      }
    },
    async downloadResource (url) {
      await axios.get('/get-download-token').then((response) => {
        let downloadToken = response.data.data.download_token
        url += '?download_token=' + downloadToken
        const link = document.createElement('a')
        link.href = url
        document.body.appendChild(link)
        if (downloadToken !== null && downloadToken !== undefined) {
          link.click()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    async sendEmailResource (data) {
      await axios.post('export/send-email-resource', data).then((response) => {

      }).catch((error) => {
        console.log(error)
      })
    },
    updateClientLocalforage (selectClient) {
      localForage.getItem('clients').then(function (clients) {
        let oldClient = clients.find(x => x.id === selectClient.id)
        if (oldClient) {
          clients.splice(clients.lastIndexOf(oldClient), 1)
        }
        clients.push(selectClient)
        localForage.removeItem('clients')
        localForage.setItem('clients', clients)
      })
    },
    deleteClientLocalforage (id) {
      localForage.getItem('clients').then(function (clients) {
        let oldClient = clients.find(x => x.id === id)
        if (oldClient) {
          clients.splice(clients.lastIndexOf(oldClient), 1)
        }
        localForage.removeItem('clients')
        localForage.setItem('clients', clients)
      })
    },
    partnerName (user) {
      user.first_name = user.first_name ? user.first_name : ''
      user.last_name = user.last_name ? user.last_name : ''
      let county = user.county ? user.county.name : ''
      return user.mentor_name ? user.mentor_name : user.first_name + ' ' + user.last_name + ' - ' + county
    },
    checkUserDefaultRole (roles, type) {
      return roles.filter(function (role) {
        if (role.name === type) {
          role.value = true
        }
      })
    },
    namingRoles (role) {
      let index = role.indexOf('.')
      if (parseInt(index) !== -1) {
        // + 1 for .
        return role.slice(index + 1, role.length)
      }
      return role
    },
    fullAddress (record) {
      let fullLocationName = ''
      if (record.county) {
        fullLocationName += record.county.name
      }
      if (record.city) {
        if (fullLocationName.length > 0) {
          fullLocationName += `, ${record.city.name}`
        } else {
          fullLocationName += record.city.name
        }
      }
      if (record.address) {
        if (fullLocationName.length > 0) {
          fullLocationName += `, ${record.address}`
        } else {
          fullLocationName += record.address
        }
      }
      if (fullLocationName.length === 0) {
        fullLocationName = '-'
      }
      return fullLocationName
    },
    $can (permissionName) {
      if (permissionName && store.getters.user) {
        if (Array.isArray(permissionName)) {
          let permissions = store.getters.user.permissions.filter(value => permissionName.includes(value))
          return (permissions.length > 0)
        } else {
          let permissions = store.getters.user.permissions.filter(value => permissionName === value)
          return (permissions.length > 0)
        }
      }
      return false
    },
    $hasRole (roleName) {
      if (roleName && store.getters.user) {
        if (Array.isArray(roleName)) {
          let roles = store.getters.user.roles.filter(value => roleName.includes(value))
          return (roles.length > 0)
        } else {
          let roles = store.getters.user.roles.filter(value => roleName === value)
          return (roles.length > 0)
        }
      }
      return false
    },
    focusSearch () {
      document.onkeypress = function () {
        let searchObject = document.getElementsByClassName('search-input')
        // let setHeight = document.getElementById('onfocusheight')
        for (let i = 0; i < searchObject.length; i++) {
          if (document.activeElement.tagName === 'BODY' || document.activeElement.id === searchObject[i].id) {
            let searchItem = searchObject[i]
            searchItem.focus()
            // setHeight.style.minHeight = '730px'
          }
        }
      }
    },

    resizableGrid (table) {
      var row = table.getElementsByTagName('tr')[0]
      var cols = row ? row.children : undefined
      if (!cols) return

      table.style.overflow = 'hidden'

      var tableHeight = table.offsetHeight

      for (var i = 0; i < cols.length; i++) {
        var div = this.createDiv(tableHeight)
        cols[i].appendChild(div)
        cols[i].style.position = 'relative'
        this.setListeners(div)
      }
    },
    paddingDiff (col) {
      if (this.getStyleVal(col, 'box-sizing') === 'border-box') {
        return 0
      }

      var padLeft = this.getStyleVal(col, 'padding-left')
      var padRight = this.getStyleVal(col, 'padding-right')
      return (parseInt(padLeft) + parseInt(padRight))
    },
    setListeners (div) {
      var pageX, curCol, nxtCol, curColWidth, nxtColWidth
      let vm = this
      div.addEventListener('mousedown', function (e) {
        curCol = e.target.parentElement
        nxtCol = curCol.nextElementSibling
        pageX = e.pageX

        var padding = vm.paddingDiff(curCol)

        curColWidth = curCol.offsetWidth - padding
        if (nxtCol) { nxtColWidth = nxtCol.offsetWidth - padding }
      })

      div.addEventListener('mouseover', function (e) {
        e.target.style.borderRight = '7px solid transparent'
      })

      div.addEventListener('mouseout', function (e) {
        e.target.style.borderRight = ''
      })

      document.addEventListener('mousemove', function (e) {
        if (curCol) {
          var diffX = e.pageX - pageX

          if (nxtCol) { nxtCol.style.width = (nxtColWidth - (diffX)) + 'px' }

          curCol.style.width = (curColWidth + diffX) + 'px'
        }
      })

      document.addEventListener('mouseup', function (e) {
        curCol = undefined
        nxtCol = undefined
        pageX = undefined
        nxtColWidth = undefined
        curColWidth = undefined
      })
    },
    createDiv (height) {
      var div = document.createElement('div')
      div.style.top = 0
      div.style.right = 0
      div.style.width = '5px'
      div.style.position = 'absolute'
      div.style.cursor = 'col-resize'
      div.style.userSelect = 'none'
      div.style.height = height + 'px'
      return div
    },
    getStyleVal (elm, css) {
      return (window.getComputedStyle(elm, null).getPropertyValue(css))
    },
    addClientToLocalForage (newClient) {
      localForage.getItem('clients').then((clients) => {
        clients.push(newClient)
        localForage.removeItem('clients')
        localForage.setItem('clients', clients)
        // ClientsService.updateConstClients()
      })
    },
    addPartnerToLocalForage (newPartner) {
      localForage.getItem('partners').then((partners) => {
        partners.push(newPartner)
        localForage.removeItem('partners')
        localForage.setItem('partners', partners)
      })
    },
    cancelDocument (storageKey, route) {
      localForage.setItem(storageKey, null).then((respones) => {
        this.$router.push(route)
      })
    }
  },
  mounted () {
    let vm = this
    document.addEventListener('click', function () {
      if (document.activeElement.getAttribute('type') === 'search') {
        return true
      } else {
        vm.selected_label = null
      }

      if (document.activeElement.closest('.form-group-select-client') === null) {
        window.$('#clients-list-dropdown').hide()
      }
    })

    let table = document.getElementById('table-resize')
    if (table) this.resizableGrid(table)
  },
  destroyed () {
    this.removeBodyClass()
  }
})

export default mixins
